import clsx from "clsx";
import { RefreshIcon } from "../Icon";

function RefreshButton({
  isRefetching,
  handleOnClick,
  isDisabled,
}: {
  isRefetching: boolean;
  handleOnClick: () => void;
  isDisabled?: boolean;
}) {
  return (
    <button type="button" onClick={handleOnClick} disabled={isDisabled} className="disabled:opacity-50">
      <RefreshIcon className={clsx("h-4 w-3 md:h-6 md:w-5", isRefetching && " animate-spin")} />
    </button>
  );
}
export default RefreshButton;
